import { Component, ElementRef, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'skeleton',
  host: {
    class: 'pulse',
    'data-testid': 'tt-skeleton',
  },
  template: ``,
  styles: [
    `
      :host {
        display: block;
        width: var(--skeleton-width);
        height: var(--skeleton-height);
        border-radius: 4px;
      }
    `,
  ],
})
export class SkeletonComponent implements OnInit {
  private host = inject<ElementRef<HTMLElement>>(ElementRef);

  width: string;
  height: string;
  className: string;

  ngOnInit() {
    const host = this.host.nativeElement;

    if (this.className) {
      host.classList.add(this.className);
    }

    host.style.setProperty('--skeleton-width', this.width ?? '100%');
    host.style.setProperty('--skeleton-height', this.height ?? '20px');
  }
}
